const makeTransformer = require('./make');
const modelTransformer = require('./model');
const warrantyTransformer = require('./warranty');
const isResolvedResource = require('../contentful/is-resolved-resource');

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,

      title: (entry.fields.title ? entry.fields.title['nb-NO'] : ''),
      fromDate: null,
      toDate: null,
      electric: false,
      van: false,
      mgImport: false,
      usedImport: false,
      make: null,
      model: null,
      warrantyDocument: null,
      standardWarrantyText: (entry.fields.standardWarrantyText ? entry.fields.standardWarrantyText['nb-NO'] : ''),
      paintWarrantyText: (entry.fields.paintWarrantyText ? entry.fields.paintWarrantyText['nb-NO'] : ''),
      rustWarrantyText: (entry.fields.rustWarrantyText ? entry.fields.rustWarrantyText['nb-NO'] : ''),
      batteryWarrantyText: (entry.fields.batteryWarrantyText ? entry.fields.batteryWarrantyText['nb-NO'] : ''),
      jsonReg: (entry.fields.jsonReg ? entry.fields.jsonReg['nb-NO'] : []),
      jsonBattery: (entry.fields.jsonBattery ? entry.fields.jsonBattery['nb-NO'] : [])
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    // Make
    if (entry.fields.make && entry.fields.make['nb-NO'] && isResolvedResource(entry.fields.make['nb-NO'])) {
      result.make = makeTransformer.contentfulToInternal(entry.fields.make['nb-NO']);
    }
    if (entry.fields.model && entry.fields.model['nb-NO'] && isResolvedResource(entry.fields.model['nb-NO'])) {
      result.model = modelTransformer.contentfulToInternal(entry.fields.model['nb-NO']);
    }

    if (entry.fields.electric) {
      result.electric = entry.fields.electric['nb-NO'];
    }

    if (entry.fields.van) {
      result.van = entry.fields.van['nb-NO'];
    }

    if (entry.fields.mgImport) {
      result.mgImport = entry.fields.mgImport['nb-NO'];
    }

    if (entry.fields.usedImport) {
      result.usedImport = entry.fields.usedImport['nb-NO'];
    }

    if (entry.fields.fromDate && entry.fields.fromDate['nb-NO']) {
      result.fromDate = new Date(entry.fields.fromDate['nb-NO']);
    }
    if (entry.fields.toDate && entry.fields.toDate['nb-NO']) {
      result.toDate = new Date(entry.fields.toDate['nb-NO']);
    }

    if (entry.fields.warrantyDocument && entry.fields.warrantyDocument['nb-NO'] && isResolvedResource(entry.fields.warrantyDocument['nb-NO'])) {
      result.warrantyDocument = warrantyTransformer.contentfulToInternal(entry.fields.warrantyDocument['nb-NO']);
    }

    return result;
  },

  internalToContentful(warranty) {
    const result = {
      fields: {
        title: {
          'nb-NO': warranty.title
        },
        model: null
      }
    };

    // Is for electric cars?
    if (typeof warranty.electric !== 'undefined') {
      result.fields.electric = {
        'nb-NO': (warranty.electric === 'true' || warranty.electric === true)
      };
    }
    // Is for vans?
    if (typeof warranty.van !== 'undefined') {
      result.fields.van = {
        'nb-NO': (warranty.van === 'true' || warranty.van === true)
      };
    }

    // Import type (MMC only)
    if (typeof warranty.mgImport !== 'undefined') {
      result.fields.mgImport = {
        'nb-NO': (warranty.mgImport === 'true' || warranty.mgImport === true)
      };
    }
    if (typeof warranty.usedImport !== 'undefined') {
      result.fields.usedImport = {
        'nb-NO': (warranty.usedImport === 'true' || warranty.usedImport === true)
      };
    }

    if (typeof warranty.standardWarrantyText !== 'undefined') {
      result.fields.standardWarrantyText = {
        'nb-NO': warranty.standardWarrantyText
      };
    }
    if (typeof warranty.paintWarrantyText !== 'undefined') {
      result.fields.paintWarrantyText = {
        'nb-NO': warranty.paintWarrantyText
      };
    }
    if (typeof warranty.rustWarrantyText !== 'undefined') {
      result.fields.rustWarrantyText = {
        'nb-NO': warranty.rustWarrantyText
      };
    }
    if (typeof warranty.batteryWarrantyText !== 'undefined') {
      result.fields.batteryWarrantyText = {
        'nb-NO': warranty.batteryWarrantyText
      };
    }

    if (typeof warranty.fromDate !== 'undefined') {
      result.fields.fromDate = {
        'nb-NO': warranty.fromDate ? warranty.fromDate.toISOString() : null
      };
    }
    if (typeof warranty.toDate !== 'undefined') {
      result.fields.toDate = {
        'nb-NO': warranty.toDate ? warranty.toDate.toISOString() : null
      };
    }

    // Make link:
    if (typeof warranty.make !== 'undefined') {
      result.fields.make = {
        'nb-NO': warranty.make ? createEntryLink(warranty.make) : null
      };
    }
    if (typeof warranty.model !== 'undefined') {
      result.fields.model = {
        'nb-NO': warranty.model ? createEntryLink(warranty.model) : null
      };
    }

    // Docuemtn entity link:
    if (typeof warranty.warrantyDocument !== 'undefined') {
      result.fields.warrantyDocument = {
        'nb-NO': warranty.warrantyDocument ? createEntryLink(warranty.warrantyDocument) : null
      };
    }

    if (typeof warranty.jsonReg !== 'undefined') {
      result.fields.jsonReg = {
        'nb-NO': warranty.jsonReg
      };
    }
    if (typeof warranty.jsonBattery !== 'undefined') {
      result.fields.jsonBattery = {
        'nb-NO': warranty.jsonBattery
      };
    }

    return result;
  }
};
